

var store_hours = [{
  'day' : 7,
  'name': 'sunday',
  'open' : '10',
  'close' : '14'
},{
  'day' : 1,
  'name': 'monday',
  'open' : '9',
  'close' : '17'
},{
  'day' : 2,
  'name': 'tuesday',
  'open' : '9',
  'close' : '17'
},{
  'day' : 3,
  'name': 'wednesday',
  'open' : '9',
  'close' : '17'
},{
  'day' : 4,
  'name': 'thursday',
  'open' : '9',
  'close' : '17'
},{
  'day' : 5,
  'name': 'friday',
  'open' : '9',
  'close' : '13'
}]

var tomorrow_text = '<a class="store-closed" href="https://maps.app.goo.gl/ubbcVp42XhMhmST18">Visit Tomorrow</a>';
var closed_text = '<a class="store-closed" href="https://maps.app.goo.gl/ubbcVp42XhMhmST18">Closed Now!</a>';
var open_text = '<a class="store-open" href="https://maps.app.goo.gl/ubbcVp42XhMhmST18">Open Now!</a>';

function checkIfOpenNow(){
  var now = new Date();
  var openToday = storeOpen(now.getDay())
  if(openToday){
    return open_text
  }else{
    var openNextDay = storeOpen(now.getDay() + 1);
    if(openNextDay){
      return tomorrow_text
    }else{
      return closed_text
    }
  }
}

function storeOpen(day){
  var now = new Date();
  var hours = store_hours.find(sh => {
    return sh.day === day;
  });
  if(hours){
      if(now.getHours() >= Number(hours.open) && now.getHours() < Number(hours.close)){
        return true
      }else{
        return false
      }
  }else{
    return false;
  }
  console.log(hours)
}

if(!Shopify.designMode){
  new Shortcode(document.querySelector('body'), {
    store_hours: function() {
      return checkIfOpenNow();
    }
  });
}

document.querySelectorAll('.product-variant-picker__pill-list:not(.theme-with-size5-swatch-in-product-section) .pill--large').forEach(function(elm){
  
  elm.addEventListener('click', function(){
    elm.closest('.product-variant-picker__pill-list').previousElementSibling.querySelector('.selected-option').innerText = elm.innerText;
  })
})

document.querySelectorAll('.product-variant-picker__pill-list .pill__color-swatch').forEach(function(elm){
  
  elm.addEventListener('click', function(){
    var color = elm.getAttribute('data-color');
    elm.closest('.product-variant-picker__pill-list').previousElementSibling.querySelector('.selected-option').innerText = color;
  })
})

document.querySelectorAll('[href="#chat"]').forEach(function(elm){
  
  elm.addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('#ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
    return false;
  })
})